/** Monto compacto para etiquetas de gráfico: "₡90.5M", "₡820k". */
export function formatearCompacto(v: number): string {
  const signo = v < 0 ? '-' : '';
  const abs = Math.abs(v);
  if (abs >= 1_000_000) return `${signo}₡${(abs / 1_000_000).toFixed(1)}M`;
  if (abs >= 1_000) return `${signo}₡${(abs / 1_000).toFixed(0)}k`;
  return `${signo}₡${abs.toFixed(0)}`;
}

/** Barras horizontales Ingreso (verde) / Gasto (rojo) por máquina, un par por fila. */
export function GraficoBarrasIngresoGasto({
  datos,
}: {
  datos: { etiqueta: string; ingreso: number; gasto: number }[];
}) {
  const max = Math.max(1, ...datos.flatMap((d) => [d.ingreso, d.gasto]));
  return (
    <div className="space-y-3">
      {datos.map((d) => (
        <div key={d.etiqueta}>
          <p className="truncate text-xs font-medium mb-1" title={d.etiqueta}>
            {d.etiqueta}
          </p>
          <div className="flex items-center gap-2">
            <div className="flex-1 h-3 rounded bg-zinc-100 overflow-hidden">
              <div
                className="h-3 bg-green-500 rounded"
                style={{ width: `${Math.max(1, (d.ingreso / max) * 100)}%` }}
              />
            </div>
            <span className="w-16 shrink-0 text-right text-[10px] tabular-nums text-muted-foreground">
              {formatearCompacto(d.ingreso)}
            </span>
          </div>
          <div className="flex items-center gap-2 mt-0.5">
            <div className="flex-1 h-3 rounded bg-zinc-100 overflow-hidden">
              <div
                className="h-3 bg-red-400 rounded"
                style={{ width: `${Math.max(1, (d.gasto / max) * 100)}%` }}
              />
            </div>
            <span className="w-16 shrink-0 text-right text-[10px] tabular-nums text-muted-foreground">
              {formatearCompacto(d.gasto)}
            </span>
          </div>
        </div>
      ))}
      <div className="flex items-center gap-4 pt-1 text-[11px] text-muted-foreground">
        <span className="flex items-center gap-1">
          <span className="h-2 w-2 rounded-full bg-green-500" /> Ingreso
        </span>
        <span className="flex items-center gap-1">
          <span className="h-2 w-2 rounded-full bg-red-400" /> Gasto
        </span>
      </div>
    </div>
  );
}
